import { Builder, CustomSerializer, Field, From, inc, Schema, use } from '@bonusly/schema';

export enum GroupType {
	And = 'AND',
	Or = 'OR',
}

export class NullableConditionsSerializer extends CustomSerializer {
	deserialize(data: any): Condition[] {
		return data ? data.map((condition: any) => Schema.deserialize(Condition, condition)) : null;
	}

	serialize(data: Condition[]): any {
		return data ? data.map((condition) => Schema.serialize(condition)) : null;
	}
}

@Schema()
export class Condition {
	@Field()
	@From('attr')
	public attr = '';

	@Field()
	@From('value')
	public value = '';
}

@Schema()
export class RuleGroup {
	@Field()
	@From('id')
	public id = '';

	@Field()
	@From('groupType')
	public groupType = GroupType.And;

	@Field([Condition])
	@From('conditions')
	public conditions: Condition[] = [];
}

export const ConditionBuilder = new Builder(Condition, {
	attr: 'location',
	value: '1',
});

export const RuleGroupBuilder = new Builder(RuleGroup, {
	id: inc(String),
	conditions: use([ConditionBuilder]),
	groupType: GroupType.Or,
});
